import { FC, useState } from 'react';
import Text, { TextColor, TextVariant } from 'src/components/atoms/Text';
import Modal, { ModalVariant } from 'src/components/organisms/Modal';
import ListCheckNoteField from './ListCheckNoteField';
import { listCheckCopy } from './listCheckCopy';

interface ProviderMismatchModalProps {
  isLoading: boolean;
  onConfirm: (note: string) => void;
  onCancel: () => void;
}

const ProviderMismatchModal: FC<ProviderMismatchModalProps> = ({
  isLoading,
  onConfirm,
  onCancel
}) => {
  const [note, setNote] = useState('');
  return (
    <Modal
      title={listCheckCopy.mismatchModalTitle}
      showModal
      variant={ModalVariant.danger}
      labelButtonConfirm={listCheckCopy.mismatchModalConfirm}
      labelButtonCancel={listCheckCopy.modalCancel}
      isLoadingButtonConfirm={isLoading}
      isDisabledButtonConfirm={isLoading || !note.trim()}
      isDisabledButtonCancel={isLoading}
      isBackClosable={!isLoading}
      onConfirm={() => onConfirm(note.trim())}
      onCancel={onCancel}
      data-testid="list-check-mismatch-modal"
    >
      <Text color={TextColor.gray600} variant={TextVariant.normal}>
        {listCheckCopy.mismatchModalLead}
      </Text>
      <ListCheckNoteField label={listCheckCopy.mismatchNoteLabel} value={note} onChange={setNote} />
    </Modal>
  );
};

export default ProviderMismatchModal;
